export default __webpack_public_path__ + "static/media/Yash.be944d66.png";